import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import telemetry from 'legacy/src/utility/telemetry';

import RichTitle from '../assessment/RichTitle';
import './AssignmentTitle.scss';

const setTrackingData = (event_type, result_id) => ({
  event_type,
  params: { result_id },
});

const AssignmentTitle = (props) => {
  const {
    title,
    optionalTitle,
    classes,
    allowPPCCustomName,
    isQB,
    rId,
    size,
    tracking,
    ...rest
  } = props;

  const hSize = () => {
    const assignmentTitle = isQB
      ? optionalTitle || title
      : title || optionalTitle;

    if (size === 'small') {
      return (
        <h3
          className="ahd__title"
          onClick={() =>
            tracking.trackEvent(setTrackingData('results_open_result', rId))
          }
          {...rest}
        >
          <RichTitle title={assignmentTitle} />
        </h3>
      );
    }

    return (
      <h2
        className="ahd__title"
        onClick={() =>
          tracking.trackEvent(setTrackingData('results_open_result', rId))
        }
        {...rest}
      >
        <RichTitle title={assignmentTitle} />
      </h2>
    );
  };

  return (
    <div className={cn('assignment_title', classes)}>
      {hSize()}
      {allowPPCCustomName &&
        !isQB &&
        title &&
        optionalTitle &&
        String(optionalTitle) !== String(title) && (
          <RichTitle title={optionalTitle} />
        )}
    </div>
  );
};

AssignmentTitle.propTypes = {
  size: PropTypes.oneOf(['small', 'large']),
  isQB: PropTypes.bool,
};

AssignmentTitle.defaultProps = {
  size: 'small',
  isQB: false,
};

export default connect((state) => ({
  allowPPCCustomName: state.featureFlag.ppc_custom_name,
}))(telemetry({})(AssignmentTitle));
